import Multiselect from "multiselect-react-dropdown";
import "rc-slider/assets/index.css";
import React from "react";
import { Accordion } from "react-bootstrap";
import { BsFilter } from "react-icons/bs";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import CustomAccordion from "../../components/Accordion/Accordion";
import Input from "../../components/Input";
import StarRating from "../../components/StarRating";
import { categories } from "../../utils/cate_mock";
import { packages } from "../../utils/packages_mock";
import { services } from "../../utils/services_mock";
const LeftSidebar = ({
  onTitleFilter,
  onDateFilter,
  onRatingFilter,
  onCategoryFilter,
  onServiceFilter,
  show,
  setShow,
  sidebarMinimize,
  setSidebarMinimize,
}) => {
  const handleRating = (newRating) => {
    onRatingFilter(newRating);
  };
  const handleInput = (e) => {
    switch (e.target.name) {
      case "title":
        return onTitleFilter(e.target.value);
      case "date":
        return onDateFilter(e.target.value);
      case "service":
        return onServiceFilter(e.target.value);
      case "category":
        return onCategoryFilter(e.target.value);
      default:
        break;
    }
  };

  // types of income select item
  const onSelect = (_, selectedItem) => {
    if (selectedItem.category) {
      console.log(selectedItem);
    }
    if (selectedItem.service) {
      console.log(selectedItem);
    }
    if (selectedItem.package) {
      console.log(selectedItem);
    }
  };
  // types of income remvoe item
  const onRemove = (_, removedItem) => {
    console.log(removedItem);
  };

  return (
    <>
      {sidebarMinimize ? (
        <div className="heading" onClick={() => setSidebarMinimize(false)}>
          <h2>
            <span>
              <FiArrowRight />
            </span>
          </h2>
        </div>
      ) : (
        <>
          <div className="heading">
            <h2>
              <span>
                <BsFilter /> Filter
              </span>
              <span>
                {show ? (
                  <h3 onClick={() => setShow(false)} className="text-danger">close</h3>
                ) : (
                  <FiArrowLeft onClick={() => setSidebarMinimize(true)} />
                )}
              </span>
            </h2>
          </div>
          <Accordion defaultActiveKey={["0", "1"]} alwaysOpen>
            {/* Category filter */}
            <CustomAccordion eventKey="0" header="Category">
              <div className="category">
                <Multiselect
                  displayValue="category"
                  onRemove={onRemove}
                  onSelect={onSelect}
                  options={categories}
                  placeholder="Select category"
                  showArrow={true}
                  singleSelect
                />
              </div>
            </CustomAccordion>
            {/* title filter */}
            <CustomAccordion eventKey="1" header="Title">
              <div className="title_field">
                <Input
                  type="text"
                  className="form-control"
                  name="title"
                  disabled={false}
                  placeholder="Search by title..."
                  onChange={handleInput}
                />
              </div>
            </CustomAccordion>
            {/* Date filter */}
            <CustomAccordion eventKey="2" header="Date">
              <div className="date_field">
                <form>
                  <Input
                    type="date"
                    className="form-control"
                    name="date"
                    disabled={false}
                    onChange={handleInput}
                  />
                </form>
              </div>
            </CustomAccordion>
            {/* Rating filter */}
            <CustomAccordion eventKey="3" header="Rating">
              <div className="rating_field">
                <StarRating
                  onClick={handleRating}
                  ratingTimes={[5, 4, 3, 2, 1]}
                  size={20}
                />
              </div>
            </CustomAccordion>
            {/* Service filter */}
            <CustomAccordion eventKey="4" header="Service/Product">
              <div className="service">
                <Multiselect
                  displayValue="service"
                  onRemove={onRemove}
                  onSelect={onSelect}
                  options={services}
                  placeholder="Select service"
                  showArrow={true}
                  singleSelect
                />
              </div>
            </CustomAccordion>
            {/* Package filter */}
            <CustomAccordion eventKey="5" header="Package">
              <div className="package">
                <Multiselect
                  displayValue="package"
                  onRemove={onRemove}
                  onSelect={onSelect}
                  options={packages}
                  placeholder="Select package"
                  showArrow={true}
                  singleSelect
                />
              </div>
            </CustomAccordion>
          </Accordion>
        </>
      )}
    </>
  );
};

export default LeftSidebar;
